import { render, staticRenderFns } from "./GroupbuyingsDetailCloseInfo.vue?vue&type=template&id=71e92374&"
import script from "./GroupbuyingsDetailCloseInfo.vue?vue&type=script&lang=js&"
export * from "./GroupbuyingsDetailCloseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports